import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { services } from '../data/services';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="w-full bg-navy-50/60 py-20 sm:py-24" data-id="element-283" data-mp="18vr05uqxknk3">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-284" data-mp="13vl667x6uoyu">
        <Reveal data-id="element-285" data-mp="13x61hzrbubxr">
          <SectionHeading eyebrow={t('services.eyebrow')} title={t('services.title')} description={t('services.sub')} data-id="element-286" data-mp="13xplrn4g9cey" />
        </Reveal>

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-287" data-mp="u3yy2kg5d60b">
          {services.map((service, index) => {
          const Icon = service.icon;
          const featured = index === 0;
          return <Reveal key={service.id} as="li" delay={index * 0.05} className={featured ? 'sm:col-span-2' : ''} data-id="element-288" data-mp="g6k6pa6c2o5p" data-mpi={index}>
                <div className="group flex h-full flex-col rounded-xl border border-navy-900/10 bg-white p-6 shadow-card transition-[border-color,box-shadow,transform] duration-200 ease-smooth hover:-translate-y-0.5 hover:border-amber-600/60 hover:shadow-lift sm:p-7" data-id="element-289" data-mp="3b2xwhpchizkg">
                  <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-navy-900 text-white transition-colors duration-200 ease-smooth group-hover:bg-amber-600" data-id="element-290" data-mp="328rwtmfgp8g8">
                    <Icon className="h-6 w-6" strokeWidth={2.1} aria-hidden="true" data-id="element-291" data-mp="3u1ilnbutfuvg" />
                  </span>
                  <h3 className="mt-5 font-display text-xl font-extrabold text-navy-900" data-id="element-292" data-mp="3g2149hjunjw4">
                    {t(service.titleKey)}
                  </h3>
                  <p className="mt-2.5 text-[15px] leading-relaxed text-navy-900/70" data-id="element-293" data-mp="24mukk6rodzcq">
                    {t(service.descKey)}
                  </p>
                  <a href="#contact" className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-bold text-brand-600 transition-colors duration-150 ease-smooth hover:text-amber-600" data-id="element-294" data-mp="29k463bby1qva">
                    {t('services.cta')}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-295" data-mp="1gpy0i99k6e6f" />
                  </a>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}